function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { cn } from "../../../lib/utils";
import React from 'react';
import { useTheme } from "../../../lib/hooks/useTheme";
import * as styles from "./divider";
import { jsx as _jsx } from "react/jsx-runtime";
var Divider = function Divider(_ref) {
  var className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'horizontal' : _ref$type,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'center' : _ref$orientation,
    _ref$line = _ref.line,
    line = _ref$line === void 0 ? 'solid' : _ref$line,
    theme = _ref.theme;
  var _useTheme = useTheme(),
    _useTheme2 = _slicedToArray(_useTheme, 1),
    originTheme = _useTheme2[0];
  var t = theme || originTheme;
  return /*#__PURE__*/_jsx("div", {
    style: style,
    className: cn(className, styles.divider, styles[type], styles[line], styles[orientation], t === 'dark' ? styles.darkTheme : styles.lightTheme),
    children: children ? /*#__PURE__*/_jsx("span", {
      className: styles.dividerContent,
      children: children
    }) : null
  });
};
export default Divider;